import { useParams } from '@tanstack/react-router'
import { AgreementsManagement } from './AgreementsManagement'
import { SingleAgreementPage } from './SingleAgreementPage'
import { Paths } from '@/routes/paths'
import { CreateAgreementPage } from '@/pages/agreements/CreateAgreementPage'

export const ContractsCnt = () => {
  const params = useParams({ strict: false }) as { contractId?: string }

  if (params.contractId) {
    return <SingleAgreementPage contractId={params.contractId} />
  }

  if (location.href.includes(Paths.Management.NewContract)) {
    return <CreateAgreementPage />
  }

  return <AgreementsManagement />
}
